import { ArrowUpRight } from "lucide-react";
import { IMAGES, SALON, SERVICES } from "@/data/salon";
import { Overline, Reveal } from "@/components/Reveal";

const Services = () => (
    <section
        id="servizi"
        data-testid="services-section"
        className="py-24 md:py-32 bg-sand"
    >
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid lg:grid-cols-[1fr_1.4fr] gap-14 lg:gap-20">
            <div>
                <div className="lg:sticky lg:top-28">
                    <Reveal>
                        <Overline>I Nostri Servizi</Overline>
                        <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink mt-4">
                            Tutto ciò che i tuoi capelli{" "}
                            <em className="italic text-rosegold">desiderano</em>
                        </h2>
                        <p className="mt-6 text-stone2 text-base md:text-lg leading-relaxed max-w-sm">
                            Ogni servizio inizia con una consulenza personalizzata e
                            finisce solo quando sei davvero soddisfatta.
                        </p>
                        <a
                            href={SALON.phoneHref}
                            data-testid="services-cta-call"
                            className="group mt-8 inline-flex items-center gap-2 text-sm tracking-[0.12em] uppercase text-ink border-b border-ink pb-1 hover:text-sage hover:border-sage transition-colors duration-300"
                        >
                            Chiedi disponibilità
                            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                        </a>
                    </Reveal>
                    <Reveal delay={0.15} className="mt-12 hidden lg:block">
                        <div className="overflow-hidden border border-linen/70">
                            <img
                                src={IMAGES.cerimonia}
                                alt="Acconciatura da cerimonia realizzata da Moovie Parrucchieri"
                                className="w-full aspect-[3/4] object-cover object-top hover:scale-[1.03] transition-transform duration-700"
                            />
                        </div>
                    </Reveal>
                </div>
            </div>

            <div>
                {SERVICES.map((s, i) => (
                    <Reveal key={s.n} delay={i * 0.06} y={20}>
                        <div
                            data-testid={`service-item-${s.n}`}
                            className="group border-t border-linen py-7 md:py-8 grid grid-cols-[auto_1fr_auto] items-baseline gap-5 md:gap-8 cursor-default"
                        >
                            <span className="font-serif italic text-lg md:text-xl text-sage">
                                {s.n}
                            </span>
                            <div>
                                <h3 className="font-serif text-2xl md:text-3xl text-ink leading-snug group-hover:translate-x-2 transition-transform duration-500">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-sm md:text-base text-stone2 leading-relaxed max-w-xl">
                                    {s.desc}
                                </p>
                            </div>
                            <ArrowUpRight
                                size={20}
                                className="text-linen group-hover:text-rosegold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300 self-center"
                            />
                        </div>
                    </Reveal>
                ))}
                <div className="border-t border-linen" />
            </div>
        </div>
    </section>
);

export default Services;
